// Fetch for the API: same origin, cookies, Problem Details turned into an ApiError.
export type { Me } from '@aldorock-fordon/shared/api-types';

export type FieldError = { path: string; message: string };

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly errors: FieldError[];
  constructor(status: number, code: string, title: string, errors: FieldError[] = []) {
    super(title);
    this.status = status;
    this.code = code;
    this.errors = errors;
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api/v1${path}`, {
      credentials: 'same-origin',
      ...init,
      headers: {
        Accept: 'application/json',
        ...(init.body && !(init.body instanceof FormData)
          ? { 'Content-Type': 'application/json' }
          : {}),
        ...init.headers,
      },
    });
  } catch {
    throw new ApiError(0, 'network', '');
  }
  if (res.status === 204) return undefined as T;
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new ApiError(res.status, body?.code ?? 'error', body?.title ?? '', body?.errors ?? []);
  }
  return body as T;
}
